<template>
	<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="スタッフ一覧" icon="format-list-bulleted">
		<b-button slot="button" type="is-success" @click="onNewButtonClick">新規作成</b-button>
		<staff-table-toolbar slot="toolbar" :customers="customers" @search-button-click="onSearchButtonClick"/>
		<staff-table :data="data" :totalNum="totalNum" :isLoading="isLoading" :checkable="false"/>
	</card>
</template>

<script>
import Card from "@/components/Card";
import StaffTable from "@/components/StaffTable";
import StaffTableToolbar from "@/components/StaffTableToolbar";
import qs from 'qs';

export default {
	name: 'staff',
	components: {
		Card,
		StaffTable,
		StaffTableToolbar,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			totalNum: 0,
			customers: [],
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['スタッフ管理']
		});
	},
	methods: {
		onNewButtonClick: function() {
			this.$router.push({ name: 'staff-new' });
		},
		onSearchButtonClick: function(isRetireeContain, customerId) {
			this.getData(isRetireeContain, customerId);
		},
		init: function() {
			this.getData();
		},
		getData: async function(isRetireeContain = false, customerId = '') {
			this.isLoading = true;
			let data = {
				"is_retiree_contain": isRetireeContain ? 1 : 0,
				"customer_id": customerId,
			};
			this.$utils.log(data);

			let ep = 'staffs?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data.list) {
					this.data = [];
				} else {
					this.data = res.data.list;
				}
				this.totalNum = this.data.length;
				this.customers = res.data.customers;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
	},
}
</script>

<style scoped>
</style>
